import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { isAfter } from 'date-fns';
@Injectable({
    providedIn: 'root',
})
export class TokenService {
    constructor() {}

    saveToken(token: string) {
        localStorage.setItem('token', token);
    }

    getToken() {
        return localStorage.getItem('token');
    }

    deleteToken() {
        localStorage.removeItem('token');
    }

    getTokenValues() {
        const token = this.getToken();
        if (token) {
            const decodedToken = jwtDecode(token);
            return decodedToken;
        }
        return null;
    }
    hasRole(role: string): boolean {
        const values = this.getTokenValues() as any;
        const accesses = values?.access ?? [];
        return accesses.some((access: any) => (access.roles ?? []).includes(role));
    }

    isViewer(): boolean {
        return this.hasRole('MERCHANT_VIEWER');
    }

    isTokenExpired() {
        let response = true;
        const tokenValue = this.getTokenValues();
        if (tokenValue) {
            const expiredDate = new Date(tokenValue.exp! * 1000);
            const now = new Date();
            response = isAfter(now, expiredDate);
        }
        return response;
    }
}